export const statusColorTransitionClass =
  'transition-colors duration-300 ease-in-out motion-reduce:transition-none';

// Explicit utilities allow Nuxt UI to merge away its default control geometry.
export const statusPillClass = `min-h-6 w-48 shrink-0 justify-center gap-1.5 rounded-full px-3 py-1 text-xs leading-none whitespace-nowrap ${statusColorTransitionClass}`;
